/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Wrapuptimeseconds3Inputs */

const en_queue_wrapuptimeseconds3 = /** @type {(inputs: Queue_Wrapuptimeseconds3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrap-up Time (seconds)`)
};

const de_queue_wrapuptimeseconds3 = /** @type {(inputs: Queue_Wrapuptimeseconds3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachbearbeitungszeit in Sekunden`)
};

/**
* | output |
* | --- |
* | "Wrap-up Time (seconds)" |
*
* @param {Queue_Wrapuptimeseconds3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const queue_wrapuptimeseconds3 = /** @type {((inputs?: Queue_Wrapuptimeseconds3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Wrapuptimeseconds3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_queue_wrapuptimeseconds3(inputs)
	return de_queue_wrapuptimeseconds3(inputs)
});
export { queue_wrapuptimeseconds3 as "queue_wrapUpTimeSeconds" }